import { getOrderLineItemQuantityDiff } from './selectors';
import { variantWithSku } from 'common/selectors';
import { getAnalytics } from 'common/analytics';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as c from './appConstants';

const itemProperties = (lineItem, state) => {
  const spreeVariant = variantWithSku(lineItem.sku, state);
  if (spreeVariant === null) return null;
  return {
    product_id: spreeVariant.sku,
    sku: spreeVariant.sku,
    name: spreeVariant.name,
    image_url: spreeVariant.image_url,
    price: parseFloat(spreeVariant.price),
    quantity: lineItem.quantity,
  };
};

export const cartContentsChanged = (orderPrev, orderNew, state) => {
  getOrderLineItemQuantityDiff(orderPrev, orderNew, state).forEach(
    ({ quantityDiff, lineItemNew }) => {
      let eventName;
      if (quantityDiff === 0) {
        return;
      } else if (quantityDiff > 0) {
        eventName = c.PRODUCT_ADDED;
      } else {
        eventName = c.PRODUCT_REMOVED;
      }
      const properties = itemProperties(lineItemNew, state);
      // If we can't find the item, then we need to bail. This can happen in the
      // case that a user has a stale item in their cart.
      if (properties === null) return;
      properties.quantity = Math.abs(quantityDiff);
      properties.path = window.location.pathname;
      properties.products = orderNew.line_items.map(lineItem =>
        itemProperties(lineItem, state)
      );
      getAnalytics().track(eventName, properties);
    }
  );
};

export const orderMembershipStatusChanged = (
  isMembershipOrder,
  eventLocation
) => {
  const eventName = isMembershipOrder
    ? c.AUTO_SHIP_ENABLED
    : c.AUTO_SHIP_DISABLED;

  getAnalytics().track(eventName, {
    eventLocation,
  });
};

export const quickShopModalVisibilityChanged = (isOpen, variants, state) => {
  const interaction = isOpen
    ? c.OPEN_QUICK_SHOP_MODAL
    : c.CLOSE_QUICK_SHOP_MODAL;
  const flavor = variants
    ? variants[0].flavor
    : state.selectedQuickShopVariant.flavor;

  getAnalytics().track(c.QUICK_SHOP_INTERACTION, {
    interaction,
    flavor,
  });
};

export const quickShopVariantChanged = (newVariant, state) => {
  const previousVariant = state.selectedQuickShopVariant;
  let interaction;

  if (!previousVariant) {
    // don't send an event on page load
    // does not represent a user action
    return;
  }

  if (newVariant.nicotineStrength !== previousVariant.nicotineStrength) {
    interaction = `${c.NICOTINE_STRENGTH} - ${newVariant.nicotineStrength}`;
  } else if (newVariant.podCount !== previousVariant.podCount) {
    interaction = `${c.POD_PACK_SIZE} - ${newVariant.podCount}`;
  }

  getAnalytics().track(c.QUICK_SHOP_INTERACTION, {
    interaction,
    flavor: newVariant.flavor,
  });
};

export const convertToSubscription = (sourceOrder, state) => {
  getAnalytics().track(c.CONVERT_TO_SUBSCRIPTION_CLICKED, {
    sourceOrder,
    order: state.currentOrder,
  });
};

export const subscribeOrOneTimePurchaseSelected = purchaseType => {
  const purchaseTypeEvent =
    purchaseType === 'onetime'
      ? c.ONE_TIME_OPTION_SELECTED
      : c.SUBSCRIBE_OPTION_SELECTED;

  getAnalytics().track(purchaseTypeEvent);
};

export const addToCartAndSubscribeClicked = () => {
  getAnalytics().track(c.ADD_TO_CART_AND_SUBSCRIBE_CLICKED);
};
